import { useCallback } from 'react'
import { useBrowerStorage } from '../useBrowserStorage'
import { COMPETITIONS_BOTTOM_BAR_CONFIG } from '../../config/competitionsBottomBarConfig'
import { useClearUserCompetitionCache } from './useClearUserCompetitionCache'

const EMPTY_ARRAY = []
const FAVORITE_COMPETITIONS_VALIDATION = (x: any) =>
    Array.isArray(x) && x.every((v) => typeof v === 'number')

export const useFavoriteCompetitions = (): {
    favorites: number[]
    addFavorite: (v: number) => void
    removeFavorite: (v: number) => void
} => {
    const { value: favorites, setValue: setFavorites } = useBrowerStorage<number[]>({
        key: COMPETITIONS_BOTTOM_BAR_CONFIG.FAVORITE.LOCAL_STORAGE_KEY,
        defaultValue: EMPTY_ARRAY,
        getItemValidation: FAVORITE_COMPETITIONS_VALIDATION,
    })

    const { clearUserCompetitionCache } = useClearUserCompetitionCache()

    const addFavorite = useCallback(
        (extCompetitionIdToAdd: number) => {
            setFavorites((p) =>
                p.includes(extCompetitionIdToAdd) ? p : [extCompetitionIdToAdd, ...p],
            )
            // reset cached user competitions
            clearUserCompetitionCache()
        },
        [clearUserCompetitionCache, setFavorites],
    )

    const removeFavorite = useCallback(
        (extCompetitionIdToRemove: number) => {
            setFavorites((p) =>
                p.includes(extCompetitionIdToRemove)
                    ? p.filter((x) => x !== extCompetitionIdToRemove)
                    : p,
            )
            // reset cached user competitions
            clearUserCompetitionCache()
        },
        [clearUserCompetitionCache, setFavorites],
    )

    return { favorites, addFavorite, removeFavorite }
}
